import imageUrl from 'Helpers/filters/image-url';

// TODO: preload with smooth showing
const defStyle = {
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  height: '100%',
};

function setImage(el, url) {
  Object.assign(el.style, { backgroundImage: `url(${url})` });
}

function getUrl(binding) {
  if (binding.arg) {
    return imageUrl(binding.value, binding.arg);
  }
  return binding.value;
}

export default {
  bind(el, binding) {
    Object.assign(el.style, defStyle);
    setImage(el, getUrl(binding));
  },
  update(el, binding) {
    setImage(el, getUrl(binding));
  },
};
